import aftersalesRoutes from './module/aftersales';  	// 售后工单
import financeRoutes from './module/finance';  			// 资产管理
import assetsRoutes from './module/assets';  			// 资产管理
import affairsRoutes from './module/affairs';  			// 人事管理
import otherRoutes from './module/other';  				// 其他页面

export default [{
	path: '/',
	component: () => import('@/pages/index'),
	children: [{
		path: '',
		name: 'home',
		meta: {
			loginFree: true
		},
		props: route => route.query,
		component: () => import('@/pages/home/index')
	}, {
		path: 'bind',
		meta: {
			loginFree: true
		},
		props: route => route.query,
		component: () => import('@/pages/bind')
	}].concat(otherRoutes)
}, {
	path: '/aftersales',
	component: () => import('@/pages/index'),
	children: [
		...aftersalesRoutes
	]
}, {
	path: '/finance',
	component: () => import('@/pages/index'),
	children: [
		...financeRoutes
	]
}, {
	path: '/assets',
	component: () => import('@/pages/index'),
	children: [
		...assetsRoutes
	]
}, {
	path: '/affairs',
	component: () => import('@/pages/index'),
	children: [
		...affairsRoutes
	]
}, {
	path: '*',
	redirect: '/'
}];